import { useProductStore } from '../../ProductProvider';
import GetProductData from '../GetProductData';
import EfProductMultiSpec from '@elem/ui/ef-product-multi-spec';
import { formatMultiSpecData } from 'elem/utils/formatMultiSpecData';

export default function TabSpecs({ theme }: { theme: any }) {
    const { productPageData } = useProductStore();
    const { productCatagory, productSeries = [] } = productPageData;

    return (
        <>
            <GetProductData />
            {productCatagory && productSeries?.length > 0 && (
                <EfProductMultiSpec
                    items={[...productSeries]}
                    catagories={formatMultiSpecData(productCatagory, [...productSeries])}
                    theme={theme}
                />
            )}
        </>
    );
}
